import { locales, getLocalized, validateLocale } from '../locales';
function dayNameBuilder(_a) {
    var format = _a.format, locale = _a.locale;
    var requestedLocale = getLocalized(locale);
    var validLocale = validateLocale(locale);
    var weekStartsOn = (locales[validLocale].options && locales[validLocale].options.weekStartsOn) || 0;
    var days = [];
    for (var d = 0; d < 7; d++) {
        days.push(requestedLocale.day(d, { width: format }));
    }
    while (weekStartsOn > 0) {
        days.push(days.shift());
        weekStartsOn--;
    }
    return days;
}
export default dayNameBuilder;
//# sourceMappingURL=dayNameBuilder.js.map